var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group",class:[
     _vm.size ? 'btn-group-' + _vm.size : '']},_vm._l((_vm.initData),function(item,index){return _c('ngmm-button',{key:index,attrs:{"icon":item.icon || '',"disabled":item.disabled || false,"type":_vm.tabCur == item.value ? 'info': 'primary'},nativeOn:{"click":function($event){return _vm.handleClick(item.value)}}},[_vm._v("\n        "+_vm._s(item.name)+"\n    ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb5a5ea8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugin-api/packages/button/src/button-group.vue
// module id = null
// module chunks = 